import axios from "axios";

export const state = {
    insuranceinvoices: [],
};

export const getters = {
    insuranceinvoices: state => state.insuranceinvoices,
};

export const mutations = {
    setInsuranceInvoices(insuranceinvoices, newValue) { state.insuranceinvoices = newValue},
};

export const actions = {
    fetchInsuranceInvoices({ commit }) {
        axios.get('/insuranceinvoices').then(res => {
            commit('setInsuranceInvoices', res.data.invoices)
        })
    },
    filterInsuranceInvoices({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterinsuranceinvoices";
        axios.post(url, formData).then((response) => {
            commit('setInsuranceInvoices', response.data.invoices)
        })
    },
};
